import type * as React from "react";

import { cn } from "~/lib/utils";

interface PageProps extends React.HTMLAttributes<HTMLElement> {}

export function Page({ className, ...props }: PageProps) {
  return <main className={cn("mx-auto max-w-[var(--content-max)] p-8", className)} {...props} />;
}
